import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
} from "ui";

import { SidebarNavItem } from "src/components/SidebarSidebarNavItem";
import { type SidebarGroupConfig } from "src/staticData";

interface SidebarNavGroupProps {
  group: SidebarGroupConfig;
}
export function SidebarNavGroup(props: SidebarNavGroupProps) {
  return (
    <SidebarGroup>
      {props.group.label ? (
        <SidebarGroupLabel>{props.group.label}</SidebarGroupLabel>
      ) : null}
      <SidebarGroupContent>
        <SidebarMenu>
          {props.group.items.map((item) => {
            return <SidebarNavItem item={item} key={item.id ?? item.href} />;
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
